<template>
	<div id="channelList">
		<el-container>
			
			<el-header>
				<uiHeader></uiHeader>
			</el-header>
			<el-main>
				<div style="background-color: #FFFFFF; margin-bottom: 1rem; position: relative; padding: 0.5rem; text-align: left;">
					<span style="font-size: 1rem; font-weight: bold;">通道列表</span>
					<!-- <div style="position: absolute; right: 1rem; top: 0.3rem;">
						<el-button icon="el-icon-refresh-right" circle size="mini" @click="getDeviceList()"></el-button>
					</div> -->
				</div>
				<devicePlayer ref="devicePlayer"></devicePlayer>
				<!--设备列表-->
				<el-table :data="deviceChannelList" :height="winHeight" border style="width: 100%">
					<el-table-column prop="channelId" label="通道编号" width="210">
						</el-table-column>
						<el-table-column prop="name" label="通道名称" width="180">
						</el-table-column>
						<el-table-column prop="address" label="地址">
						</el-table-column>
						<el-table-column label="操作" width="240" align="center" fixed="right">
							<template slot-scope="scope">
								<el-button size="mini" @click="sendDevicePush(scope.row)">预览视频</el-button>
								<!-- <el-button size="mini" @click="sendDevicePush(scope.row)">录像查询</el-button> -->
							</template>
						</el-table-column>
				</el-table>
				<el-pagination
					style="float: right"
					@size-change="handleSizeChange"
					@current-change="currentChange"
					:current-page="currentPage"
					:page-size="count"
					:page-sizes="[15, 25, 35, 50]"
					layout="total, sizes, prev, pager, next"
					:total="total">
				</el-pagination>

			</el-main>
		</el-container>
	</div>
</template>

<script>
	 import devicePlayer from './gb28181/devicePlayer.vue'
	 import uiHeader from './UiHeader.vue'
	export default {
		name: 'channelList',
		components: {
			devicePlayer,
			uiHeader
		},
		data() {
			return {
				deviceId: this.$route.params.id,
				deviceChannelList: [],
				videoComponentList: [],
				currentPlayerInfo: {}, //当前播放对象
				updateLooper: 0, //数据刷新轮训标志
				currentDeviceChannelsLenth:0,
				winHeight: window.innerHeight - 200,
				currentPage:1,
				count:15,
				total:0
			};
		},
		computed: {
			getcurrentDeviceChannels: function() {
				let data = this.currentDevice['channelMap'];
				let channels = null;
				if (data) {
					channels = Object.keys(data).map(key => {
						return data[key];
					});
					this.currentDeviceChannelsLenth = channels.length;
				}
				
				console.log("数据：" + JSON.stringify(channels));
				return channels;
			}
		},
		mounted() {
			this.initData();
			this.updateLooper = setInterval(this.initData, 10000);
		},
		destroyed() {
			this.$destroy('videojs');
			clearTimeout(this.updateLooper);
		},
		methods: {
			initData: function() {
				this.getDeviceChannelList();
			},
			currentChange: function(val){
				this.currentPage = val;
				this.getDeviceChannelList();
			},
			handleSizeChange: function(val){
				this.count = val;
				this.getDeviceChannelList();
			},
			getDeviceChannelList: function() {
				let that = this;
				console.log(this.currentPage - 1)
				// this.$axios({
				// 	method: 'get',
				// 	url: this.$global.genGb28181Url(`/api/devices/${this.$route.params.id}/channels`)
				// }).then(function(res) {
				// 	that.deviceChannelList = res.data;
				// }).catch(function(error) {
				// 	console.log("请求失败，使用假数据");
				// });

				this.$axios.get(this.$global.genGb28181Url(`/api/devices/${this.$route.params.id}/channels`),{
					params: {
						page: that.currentPage - 1,
						count: that.count
					}
				} )
				.then(function (res) {
					console.log(res);
					that.total = res.data.total;
					that.deviceChannelList = res.data.data;
				})
				.catch(function (error) {
					console.log(error);
				});

			},
			

			//gb28181平台对接
			//刷新设备信息
			refDevice: function(itemData) {
				///api/devices/{deviceId}/sync
				console.log("刷新对应设备:" + itemData.deviceId);
				this.$axios({
					method: 'post',
					url: this.$global.genGb28181Url('/api/devices/' + itemData.deviceId + '/sync')
				}).then(function(res) {
					// console.log("刷新设备结果："+JSON.stringify(res));
				}).catch(function(e) {
					that.$message({
						showClose: true,
						message: '请求成功',
						type: 'success'
					});
				});;
			},
			//通知设备上传媒体流
			sendDevicePush: function(itemData) {
				let deviceId = this.deviceId;
				let channelId = itemData.channelId;
				console.log("通知设备推流1：" + deviceId + " : " + channelId);
				let that = this;
				this.$axios({
					method: 'get',
					url: this.$global.genGb28181Url('/api/play/' + deviceId + '/' + channelId)
				}).then(function(res) {
					let ssrc = res.data.ssrc;
					that.$refs.devicePlayer.play(ssrc,deviceId,channelId);
				}).catch(function(e) {
				});
			}

		}
	};
</script>

<style>
	.videoList {
		display: flex;
		flex-wrap: wrap;
		align-content: flex-start;
	}

	.video-item {
		position: relative;
		width: 15rem;
		height: 10rem;
		margin-right: 1rem;
		background-color: #000000;
	}

	.video-item-img {
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		margin: auto;
		width: 100%;
		height: 100%;
	}

	.video-item-img:after {
		content: "";
		display: inline-block;
		position: absolute;
		z-index: 2;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		margin: auto;
		width: 3rem;
		height: 3rem;
		background-image: url("../assets/loading.png");
		background-size: cover;
		background-color: #000000;
	}

	.video-item-title {
		position: absolute;
		bottom: 0;
		color: #000000;
		background-color: #ffffff;
		line-height: 1.5rem;
		padding: 0.3rem;
		width: 14.4rem;
	}
</style>
